import { render, staticRenderFns } from "./untrust_projects.vue?vue&type=template&id=d9b7deb8&scoped=true&"
import script from "./untrust_projects.vue?vue&type=script&lang=js&"
export * from "./untrust_projects.vue?vue&type=script&lang=js&"
import style0 from "./untrust_projects.vue?vue&type=style&index=0&id=d9b7deb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b7deb8",
  null
  
)

export default component.exports